import React from 'react';
import path from 'path';
import { promises as fs } from 'fs';
import { CurrentItemPage } from '../../components/Views/CurrentItemPage';
import Layout from '../../components/Layout/Layout';
import { makeHostSum, normalizePath } from '../../utils/helpers';
import { getStaticData } from '../../utils/helpers/getStaticData';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import {
  getCurrentItemData,
  normalizeItemPagePath
} from '../../utils/helpers/item';
import { generateItemSeoObj } from '../../utils/helpers/seo';
import { resolveCurrentItemMockFile } from '../../utils/helpers/resolveCurrentItemMockFile';
import { ItemStatusEnum } from '../../graphql/types';

const CurrentItem = props => <CurrentItemPage {...props} />;

const getCurrentItemMockData = async (params, query) => {
  const filePath = resolveCurrentItemMockFile(params.id, query);
  const currentData = path.join(
    process.cwd(),
    'cypress/mock/current_item',
    filePath
  );

  const file = await fs.readFile(currentData, 'utf-8');
  const raw = JSON.parse(file);
  return params.id === '3878205'
    ? {
        ...raw,
        data: {
          ...raw.data,
          item: {
            ...raw.data.item,
            isAuthor: false,
            isMine: false
          }
        }
      }
    : raw;
};

const getResStatusCode = item => {
  if (!item) return 404;

  const isExpired = item?.state === ItemStatusEnum.Expired;
  const isExpiredManually = !!(isExpired && item?.isExpiredManually);

  if (isExpired || isExpiredManually) return 404;

  return null;
};

export async function getServerSideProps({ res, req, params, query }) {
  if (query.mock === 'true' && process.env.NODE_ENV !== 'production') {
    const mock = await getCurrentItemMockData(params, query);
    return {
      props: {
        currentItemData: mock.data.item,
        mainPageImage: mock.data.item?.photos[0] || {}
      }
    };
  }

  const apolloClient = initApollo({}, { lang: getLocaleOnSSR(req) });
  const currentAsPath = normalizeItemPagePath(req.url);
  const newAsPath = normalizePath(currentAsPath);
  const hostSum = makeHostSum({ asPath: newAsPath, req });
  const itemId = params.id;

  const show404Page = response => {
    response.statusCode = 404;
    return { props: { statusCode: 404 } };
  };

  if (res && !currentAsPath.match(/\d+/)?.[0]) return show404Page(res);

  const [staticData, currentItemRes] = await Promise.all([
    getStaticData(apolloClient),
    getCurrentItemData(apolloClient, itemId)
  ]);

  const { currentItemData } = currentItemRes;
  const seoData = generateItemSeoObj(currentItemData, newAsPath, hostSum);

  const statusCode = getResStatusCode(currentItemData);
  if (statusCode) res.statusCode = statusCode;

  return {
    props: {
      newAsPath,
      hostSum,
      itemId,
      seoData,
      mainPageImage: currentItemData?.photos[0] || {},
      ...staticData,
      ...currentItemRes
    }
  };
}

CurrentItem.getLayout = (page, pageProps) => (
  <Layout
    isSafeAreaTop
    isBottomNavigation={false}
    isCurrentItemPage
    isBanner
    pageProps={pageProps}
    isBackgroundBanner
    hideMobileHeader
  >
    {page}
  </Layout>
);

export default CurrentItem;
